<template>
    <div class="relative">
        <div class="faqSlider">
            <div v-for="question in questions" :key="question.id">
                <QuestionCard :faq="faq" :question="question" :query="query" />
            </div>
        </div>
        <div
            class="hidden lg:flex slider-arrow faq-slider-arrow-left flex-shrink-0 h-11 w-11 rounded-full items-center justify-center border opacity-75 hover:opacity-100 absolute top-1/2 -left-14 -translate-y-1/2"
            role="button"
            tabindex="0"
            :style="{
                color: faq.titleColor,
                borderColor: faq.borderColor,
            }"
        >
            <ChevronLeftIcon class="h-5 w-5" />
        </div>
        <div
            class="hidden lg:flex slider-arrow faq-slider-arrow-right flex-shrink-0 h-11 w-11 rounded-full items-center justify-center border absolute top-1/2 -right-14 -translate-y-1/2 opacity-75 hover:opacity-100"
            role="button"
            tabindex="0"
            :style="{
                color: faq.titleColor,
                borderColor: faq.borderColor,
            }"
        >
            <ChevronRightIcon class="h-5 w-5" />
        </div>
    </div>
</template>

<script>
import QuestionCard from "./QuestionCard.vue";
import { ChevronLeftIcon, ChevronRightIcon } from "@easy/ui/icons";
import { tns } from "tiny-slider/src/tiny-slider";

export default {
    name: "SliderLayout",
    props: {
        faq: Object,
        questions: Array,
        query: String,
    },
    components: {
        QuestionCard,
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    data() {
        return {
            faqSlider: null,
        };
    },
    mounted() {
        this.startSlider();
    },
    beforeUnmount() {
        this.destroySlider();
    },
    methods: {
        startSlider() {
            "undefined" != typeof tns &&
                document.querySelector(".faqSlider") &&
                !document.querySelector(".faqSlider.tns-slider") &&
                (this.faqSlider = tns({
                    container: ".faqSlider",
                    items: 1,
                    slideBy: "page",
                    gutter: 10,
                    nextButton: document.querySelector(".faq-slider-arrow-right"),
                    prevButton: document.querySelector(".faq-slider-arrow-left"),
                    loop: !1,
                    navPosition: "bottom",
                    responsive: { 640: { items: 2 }, 1024: { items: 3, nav: false } },
                }));
        },
        destroySlider() {
            this.faqSlider?.destroy && this.faqSlider.destroy();
        },
    },
};
</script>
